import { css } from 'styled-components';

export const productListingCardsStyles = css`
  .product-listing-cards {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 20px;
    width: 100%;
    margin: 16px 0 8px;
    padding: 0;
    color: #1a1a1a;

    @media (min-width: 576px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (min-width: 992px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  /* Single product → hero card */
  .product-listing-cards:has(> .product-card:only-child) {
    grid-template-columns: 1fr;
  }

  .product-listing-cards:has(> .product-card:only-child) .product-card {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .product-listing-cards:has(> .product-card:only-child) .product-cover-image {
    height: 420px;
  }

  .product-listing-cards:has(> .product-card:only-child) .product-info {
    padding: 32px;
  }

  .product-card {
    display: flex;
    flex-direction: column;
    background: var(--off-white, #fffaf3);
    border-radius: 14px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    color: #1a1a1a;
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);
    }
  }

  .product-cover-image {
    display: block;
    width: 100%;
    height: 220px;
    max-width: 100%;
    object-fit: cover;
    object-position: center;
    flex-shrink: 0;
    border-radius: 0;
  }

  .product-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 20px 22px 22px;
    gap: 0;
    color: #1a1a1a;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 17px;
      line-height: 1.35;
      font-weight: 700;
      color: #1a1a1a !important;
      margin: 0 0 8px;
      letter-spacing: -0.01em;
    }

    p,
    .description {
      font-size: 14px;
      line-height: 1.55;
      color: #5a5a5a !important;
      margin: 0 0 12px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .price {
      font-size: 16px;
      line-height: 1.4;
      font-weight: 700;
      color: #1a1a1a !important;
      margin: 0 0 10px;
      display: block;
      -webkit-line-clamp: unset;
    }

    .feature-tags {
      font-size: 13px;
      line-height: 1.5;
      color: #6b6b6b !important;
      margin: 0 0 18px;
      padding-top: 2px;
      display: block;
      -webkit-line-clamp: unset;
    }

    .view-detail-cta {
      display: block;
      width: 100%;
      margin-top: auto;
      padding: 12px 20px;
      font-size: 14px;
      line-height: 1.2;
      font-weight: 600;
      text-align: center;
      text-decoration: none !important;
      color: #fff !important;
      background: var(--paper-2);
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover {
        background: #333;
        color: #fff !important;
        text-decoration: none !important;
      }
    }
  }

  /* Reset inherited chat link styles inside cards */
  .product-card a.view-detail-cta {
    text-decoration: none !important;
    color: #fff !important;
  }

  /* Prevent global img rules from stretching product images */
  .product-card img.product-cover-image {
    height: 220px;
    max-height: 420px;
    width: 100%;
    object-fit: cover;
  }
`;
